module.exports = __webpack_public_path__ + "static/media/Image 9.7766ea45.png";